// app/frontend/components/Cards/RecurringEventCard.tsx
import React from 'react';
import { Card, Image, Text, Stack, Box } from '@mantine/core';
import { Link } from '@inertiajs/react';
import styles from './RecurringEventCard.module.css';

interface RecurringEvent {
  id: number;
  title: string;
  slug: string;
  image?: string | null;
  recurrence_pattern: string;
  number_of_occurrences: number;
}

interface RecurringEventCardProps {
  recurringEvent: RecurringEvent;
}

export default function RecurringEventCard({ recurringEvent }: RecurringEventCardProps) {
  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      component={Link}
      href={`/re/${recurringEvent.slug}`}
      className="card"
      style={{
        cursor: 'pointer',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <Card.Section>
        {recurringEvent.image ? (
          <Image src={recurringEvent.image} height={160} alt={recurringEvent.title} fit="cover" />
        ) : (
          <Box
            h={160}
            bg="gray.6"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Text c="gray.4" size="sm">
              No Image
            </Text>
          </Box>
        )}
      </Card.Section>

      <Stack gap="4px" mt="8px">
        <Text fw={600} size="lg" c="white" lineClamp={2} className="rubik" style={{ lineHeight: 1 }}>
          {recurringEvent.title}
        </Text>

        <Text size="sm" c="white" opacity={0.8}>
          {recurringEvent.recurrence_pattern}
        </Text>

        <Text size="sm" c="white" opacity={0.7}>
          {recurringEvent.number_of_occurrences} occurrence{recurringEvent.number_of_occurrences !== 1 ? 's' : ''}
        </Text>
      </Stack>
    </Card>
  );
}
